// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SideBySide_wrapper__y3_VQ","side":"SideBySide_side__Nad6T"};